module.exports = __webpack_public_path__ + "static/media/hero.e1bcee46.jpg";